<template>
  <!-- 主体容器 -->
  <div class="main">
    <NavBar
      title="资讯详情"
      left-arrow
      fixed
      placeholder
      @click-left="goBack"
      :border="false"
    />
    <GoBack :type="0" />
    <!-- <div class="banner">
      <Swipe class="my-swipe" :autoplay="3000" indicator-color="white">
        <SwipeItem
          ><img
            src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/bjy_template/test/swiper1.jpg"
            alt=""
        /></SwipeItem>
        <SwipeItem
          ><img
            src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/bjy_template/test/swiper2.jpg"
            alt=""
        /></SwipeItem>
      </Swipe>
    </div> -->
    <div class="con" v-if="itemid == 0">
      <h2 class="title">尽速8之力，守“沪”平安</h2>
      <div class="content">
        <p>
          2022年4月，上海疫情再次吸引全国人民的目光，牵动着全国人民的心，酒店行业也因此不得不再次按下了“暂停键”。每一次危难时刻，总有这样一群人不顾自身安危勇往直前，他们虽平凡但化为了点点星火，汇聚在一起组成了代表希望的燎原之火，共同守“沪”。而这其中，也闪现着速8人的身影，从晨光初现，到万家灯火，速8人在抗疫一线上日夜奋战，从未停下脚步。
        </p>
        <p>
          2022年3月上海疫情突发，速8中国管理层第一时间成立防疫应急小组，调动上海区域运营经理与酒店负责人积极沟通，希望能为奋战在一线的各行业的疫情防控保障的逆行者提供隔离落脚点，特别是配送物资人员，贡献速8的一份绵薄之力。
        </p>
        <h5>速8全员抗疫情 疾风骤雨砺初心</h5>
        <p>
          回溯到上海疫情还未大规模爆发时，速8人就已经开始万众一心、齐头并进，积极协助配合防疫部门各项抗疫工作，接受了上海疾控中心临时征用任务，开展了相关防疫隔离准备工作，为抗疫贡献一份力。
        </p>
        <img
          src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/a1.png"
          alt=""
        />
        <p>
          2022年2月22日速8酒店上海金山学府路城市沙滩店，店长谢益敏在接到疾控中心临时征用任务后，立即组织员工启动酒店疫情防控应急预案，给店内员工发放防护服，对酒店在住客人进行紧急疏散，同时安排员工保质保量完成客房清洁、消毒以及改造工作。
        </p>
        <p>
          在征用期间，为了保证隔离客人及员工的健康和安全，谢益敏店长带领酒店工作人员严格按照政府部门和速8集团的要求布置落实相关疫情防控工作，同时加大对客房及公共区域等人员密集区域清洁消毒力度，公共区域坚持每天2次消毒，积极关注员工岗前个人防护安全情况，同时安抚店内人员情绪，在谢益敏店长带领进行疫情防控的这段日子里实现了全员零感染，店内事务也都被处理地井井有条。转眼2个月过去了，酒店又再一次迎接了更大的挑战：在疫情爆发的4月，酒店要么成为政府征用隔离点，要么就被封控管理。速8总部、大区运营经理已于当地各家酒店积极沟通与推动，寻找最优的解决良策。
        </p>
        <p>
          “坚持了这么久，很多人问我辛不辛苦，我要说不累那是假的。但是和在抗疫一线的医生相比，我们这点辛苦根本不算什么。白衣天使们在努力抗疫，在为病患治疗，我们能做的就是在自己能力范围内，尽可能地多出一份力。虽然我已经差不多两个月没有回家了，我也很想念我的家人，但我依然会坚守岗位，尽酒店人的一份力量。”谢益敏如是说道。
        </p>
        <img
          src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/a2.png"
          alt=""
        />

        <p>
          在速8，有无数我们知道或不知道的速8人正在默默的付出与守护，谢店长只是这次守“沪”战役中的一个缩影，每个人都在用自己不同的方式为防疫做贡献。
        </p>
        <h5>微光成炬，传递速8温度</h5>
        <p>
          疫情三年期间，速8人以宾客安全为己任，默默的用心坚守，永远第一时间积极响应政府需求，迅速组织防疫支援小组，积极与酒店负责人沟通，落实防疫工作。
        </p>
        <p>
          正如2020年疫情爆发之初，速8设立疫情资助专项基金，通过湖北省慈善总会捐赠防疫物资等抗疫措施，协助政府共同抗疫。2021年至2022年春节期间，速8酒店（中国）连续两年开展了“就地过年不回家，邀您免费住速8”为主题的公益活动，为身在异乡的城市建设者提供免费住宿服务，速8在用自己的方式尽全力夯实防疫安全线，构筑疫情防控堡垒。
        </p>
        <img
          src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/a3.png"
          alt=""
        />
        <h5>疫情终将过去，繁华必将如常</h5>
        <p>
          速8爱中国，始终用爱守护。全体速8人将同心协力、迎难而上，以更大的决心、更快的速度响应国家号召，筑起防控疫情的坚固防线和钢铁长城，与上海人民一起坚守阵地、共迎抗疫战争胜利。期待疫情结束那天，速8与您路上见！
        </p>
        <img
          src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/a4.png"
          alt=""
        />
      </div>
    </div>

    <div class="con" v-if="itemid == 1">
      <h2 class="title">春节这站在速8， 就地过年免费住</h2>
      <h5 style="text-align: right">——就地过年，温情再续，速8邀您免费住</h5>
      <div class="content">
        <p>
          回家过年，是每一个中国人心中最幸福的期盼，可以抛开一年的重负、可以卸下生活的压力，尽情享受与家人团聚的温暖和快乐。
        </p>
        <p>
          而今年春节，“就地过年”却再度成为热搜焦点。全国多数省份倡议就地过年、网络拜年，减少非必要出行，错峰返乡，确保疫情不因春运扩散。就地过年，虽然牺牲了很多小家的团圆，却换来了大家的安康！值得庆幸的是多数亲人们仍然能在线上见面，用科技缩小距离。每个人、每个企业为这个大家庭的安全付出一点，就能形成疫情防控的磅礴力量。
        </p>
        <p>
          2022年1月27日，在交通运输部举行的例行新闻发布会上，交通运输部新闻发言人刘鹏飞介绍了今年春运的客流情况：“今年春运至今已经10天，目前客流总体运行平稳有序。截至1月26日，也就是春运第十天，全国春运旅客发送量2.6亿人次，较2021年同期增长约46%”。由此可见，我国仍然面临较大的“外防输入，内防反弹”的压力。但令人振奋的是各行各业都在积极响应国家就地过年的号召，为疫情防护尽一份绵薄之力。
        </p>
        <p>
          在酒店行业中，速8酒店（中国）总部再次号召并策划了“就地过年，温情再续，速8邀您免费住”为主题的公益活动，将温暖带给因疫情滞留在异乡的游子。本次活动成功号召了全国1000多家在营速8酒店&速8精选酒店共同参与，齐心协力用爱持续领跑连锁加盟酒店行业的公益路。
        </p>
        <img
          src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/b1.png"
          alt=""
        />
        <h5>一、速8酒店（中国）秉承着公益之心，为异乡人带来寒冬之下的温情</h5>
        <p>
          据悉，此次公益活动已于2022年1月27日在速8酒店官方APP正式上线并开放预订，宾客可通过速8酒店官方App进入活动页面注册并申请，审核通过后即预订除夕、初一免费房。为了能够令更多就地过年的城市游子享受到免费房的服务，每一位宾客可预订一个间夜。并且，此次活动还将在2022年2月2日—2022年2月13日（正月初二—正月十三）增加春节入住特惠活动，宾客可在速8官方渠道尊享门市7折入住优惠，此优惠还可与会员折扣叠加，享受折上折。
        </p>
        <img
          src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/b2.png"
          alt=""
        />
        <h5>二、筑牢防疫安全网，强化防疫不放松，速8酒店升级管理措施</h5>
        <p>
          筑牢防疫关，安全过好年。速8酒店（中国）秉持“干净&友好”的服务理念，以高标准、严要求全力做好防疫安全工作，保障员工与宾客的健康安全：
        </p>
        <p>
          入门即测温，检查口罩佩戴情况，引导宾客完成健康码场所码扫描，守好疫情防控第一道防线；在消毒方面，围绕酒店公区、客房、后台3大空间，进行全方位消毒清洁；在硬件方面，清洁消毒用品配备齐全，房间用品坚持一客一换一消毒，全力保障宾客入住无忧；在智能化方面，速8精选酒店智能机器人为宾客提供零接触服务，送外卖、取快递等24小时送物服务，既提高效率又减少不必要的接触。速8以专业和细心筑造战疫堡垒，为身在异乡的游子们提供如家般安定的“港湾”。
        </p>
        <img
          src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/b3.png"
          alt=""
        />
        <h5>三、速8酒店丨防疫路上的先锋者，公益路上的领路人</h5>
        <p>
          唯有善者，方可行天下。在华18年来，速8（中国）首席执行官王燕婷女士用“奉献之美，速8相随”8个字总结了速8酒店的公益之路。
        </p>
        <p>
          2020年初新冠疫情爆发，速8用行动助力防疫：提供给政府隔离酒店，为受疫情影响的隔离人员送去温暖；向湖北省慈善总会捐赠300箱消毒液，又从各国调来了抗疫的物资分发到全国所有速8酒店参与抗疫大战；第一时间出台一系列针对加盟商优惠政策，如酒店经营管理费减免等重要举措，全力指导门店运营，帮助投资人渡过难关。
        </p>
        <p>
          2021年当河南郑州遭遇千年一遇特大暴雨时，速8人万众一心，共克时艰：身在灾区的所有速8酒店主动为救援队提供免费住宿和餐饮服务，不在灾区的速8酒店也心系灾情，发起爱心捐款活动，用实际行动助力灾区人民抗击灾情。同年10月，速8响应国家“用行动助力乡村振兴，用爱心惠农助农”的号召，成功举办善行者公益徒步活动，通过捐赠善款购买助农产品传递爱心，致力于让更多的人了解并参与公益。
        </p>
        <img
          src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/b4.png"
          alt=""
        />
        <p>
          未来，希望有更多的酒店品牌能够和速8酒店（中国）一样，时刻秉承公益之心，用实际行动践行社会责任。为就地过年的异乡人在春节期间提供力所能及的帮助。
        </p>
        <img
          src="https://bjyoss.oss-cn-hangzhou.aliyuncs.com/image/active/super8/b5.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import routers from "@/hooks/routers";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import GoBack from "../components/GoBack/GoBack.vue";

import { NavBar, Swipe, SwipeItem } from "vant";

export default defineComponent({
  name: "Information",
  components: { NavBar, Swipe, SwipeItem, GoBack },
  setup() {
    //路由跳转
    const { goBack } = routers();
    const store = useStore();
    const titleStatus = store.state.titleStatus;
    const route = useRoute();
    const itemid = route.query.itemid;

    return {
      titleStatus,
      goBack,
      itemid,
    };
  },
});
</script>

<style lang="scss" scoped>
.main {
  .my-swipe {
    img {
      width: 100%;
      height: auto;
    }
  }
  .con {
    padding: 0 0.15rem 0.2rem;
    .title {
      font-size: 18px;
    }
    p {
      font-size: 0.14rem;
      line-height: 0.2rem;
      text-indent: 0.28rem;
    }
    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>
